import { useRef, useState } from "react";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import {
  Center,
  Text3D,
  // OrbitControls,
  MeshTransmissionMaterial,
  // MeshPhysicalMaterial,
  // Edges,
  // useCursor,
} from "@react-three/drei";
import { useControls } from "leva";
import { Group } from "@mui/icons-material";
import * as THREE from "three";

const glowRed = new THREE.MeshBasicMaterial({
  color: new THREE.Color(7, 0, 0.5),
  toneMapped: false,
});
const glowGreen = new THREE.MeshBasicMaterial({
  color: new THREE.Color(0, 3, 1),
  toneMapped: false,
});
const glowBlue = new THREE.MeshBasicMaterial({
  color: new THREE.Color(1, 0.5, 20),
  toneMapped: false,
});

export default function NavBlocks() {
  const ref = useRef();
  // Hold state for hovered and clicked events
  const [hovered, hover] = useState(false);
  const [clicked, click] = useState(false);
  // position mesh relative to camera
  useFrame(({ camera }) => {
    // Move mesh to be flush with camera
    ref.current.position.copy(camera.position);
    // ref.current.quaternion.copy(camera.quaternion);
    // Apply offset
    ref.current.translateX(-2);
    ref.current.translateY(-8);
    ref.current.translateZ(4);
  });
  return (
    <group ref={ref} position={[6, 2, 12]}>
      <mesh
        // ref={ref}
        rotation-y={hovered ? 3.14 / 4 : 0}
        scale={hovered ? [1, 4.5, 1] : [1, 4.5, 1]}
        onClick={(event) => click(!clicked)}
        onPointerOver={(event) => (event.stopPropagation(), hover(true))}
        onPointerOut={(event) => hover(false)}
        castShadow
        onPointerEnter={() => {
          document.body.style.cursor = "pointer";
        }}
        onPointerLeave={() => {
          document.body.style.cursor = "auto";
        }}
      >
        <boxGeometry args={[1, 1, 1]} />

        <MeshTransmissionMaterial
          transmission={1}
          // backside
          backsideThickness={0.05}
          thickness={0.05}
          roughness={hovered ? 0.15 : 0.5}
          // clearcoat={0.5}
          // clearcoatRoughness={0.5}
          ior={2}
          // color={clicked ? "#85b8eb" : "transparent"}
          // envMapIntensity={5}
          // samples={16}
        />
      </mesh>
      <Center>
        <Text3D
          font="./fonts/Inter_Bold.json"
          fontSize={6}
          position={[0, 0, 0]}
          rotation={[0, 0, Math.PI / 2]}
          rotation-y={hovered ? 3.14 / 4 : 0}
          scale={0.8}
          // color="white"
          // curveSegments={10}
          // bevelThickness={10}
          // bevelSize={2}
          // bevelOffset={0}
          // bevelSegments={5}
          material={glowBlue}
        >
          HOME
        </Text3D>
      </Center>
    </group>
  );
}
